// src/admindashboardutils/components/ConversionBarChart.jsx
import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const ConversionBarChart = ({ conversionBarData }) => (
  <div className="bg-white rounded-lg p-4 shadow-md">
    <h3 className="text-lg font-medium text-gray-700 mb-4">Conversion (past 7 days)</h3>
    <div className="flex justify-center">
      <ResponsiveContainer width="100%" height={250}>
        <BarChart
          data={conversionBarData}
          margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
        >
          <XAxis
            dataKey="day"
            tick={{ fontSize: 12 }}
            interval={0} 
          />
          <YAxis
            tick={{ fontSize: 12 }}
            domain={[0, 20]} 
            allowDataOverflow={false}
          />
          <Tooltip />
          <Bar
            dataKey="conversions"
            fill="#1E90FF"
            barSize={30} 
            radius={[4, 4, 0, 0]} 
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default ConversionBarChart;